import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/reset.css'
import Vant from 'vant';
import 'vant/lib/icon/local.css';
import 'vant/lib/index.css';
import './libs/rem.js';
import directives from './directives/toggleContent';
import nextPage from './directives/nextPage';

import VueRouter from 'vue-router';
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(directives)
Vue.use(nextPage)

Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
